module.exports = __webpack_public_path__ + "MetagamingPigeon.webp?374377ca2174879785313558f0764d88";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MetagamingPigeon.webp
// module id = 138
// module chunks = 0